import { Theme } from '@mui/material';
import { Colors } from '@sweatpals/react-ui-kit';

export const buttonStyles = (theme: Theme, color?: 'primary' | 'secondary') => ({
	root: {
		display: 'flex',
		justifyContent: 'center',

		textTransform: 'uppercase',
		fontFamily: 'Integral CF',
		fontWeight: 500,
		fontSize: { xs: '8px', sm: '10px', md: '12px', lg: '14px' },
		lineHeight: '1.2',
		color: 'black',
		whiteSpace: 'nowrap',

		border: '1px solid #120E0D',
		p: { xs: '6px 12px', sm: '8px 16px', md: '12px 24px', lg: '16px 32px' },
		borderRadius: '100px',
		backgroundColor: color === 'primary' ? Colors['FF6000'] : 'white',

		'&:hover': {
			backgroundColor: color === 'primary' ? Colors['FF6000'] : Colors['FFF521'],
		},

		'&:active': {
			backgroundColor: color === 'primary' ? Colors['FF6000'] : Colors['FFF521'],
		},
	},
});
